export default [
    {
        name: 'Free',
        description: "For individuals who want to try advanced AI Speech synthesis",
        features: [
            "10K one-time welcome credits (worth about 16 mins of high-quality TTS)",
            "Text To Speech",
            "Voice Gallery",
            "Intelligent Voice Selection",
            "Add Credits as you go"
        ]
    },
    {
        name: 'Starter',
        description: "For occasional users with AI audio",
        features: [
            "100k Credits monthly (worth about 2.7 hours of high-quality TTS)",
            "Text To Speech",
            "Voice Gallery",
            "Intelligent Voice Selection",
            "Referral Program",
            "Commercial license"
        ]
    },
    {
        name: 'Creator',
        description: "For Content Creators & educational VO",
        features: [
            "300k Credits monthly (worth about 8.3 hours of high-quality TTS)",
            "Text To Speech",
            "Voice Gallery",
            "Intelligent Voice Selection",
            "Referral Program",
            "Commercial license"
        ]
    },
    {
        name: 'Standard',
        description: "For active creators ramping up content",
        features: [
            "480k Credits monthly (worth about 13.3 hours of high-quality TTS)",
            "Text To Speech",
            "Voice Gallery",
            "Intelligent Voice Selection",
            "Referral Program",
            "Commercial license"
        ]
    },
    {
        name: 'Pro',
        description: "For commercial users",
        features: [
            "1580k Credits monthly (worth about 43 hours of high-quality TTS)",
            "Text To Speech",
            "Voice Gallery",
            "Intelligent Voice Selection",
            "Referral Program",
            "Commercial license"
        ]
    },
]
